import { render, staticRenderFns } from "./editNewImageText.vue?vue&type=template&id=4544bd46&"
import script from "./editNewImageText.vue?vue&type=script&lang=ts&"
export * from "./editNewImageText.vue?vue&type=script&lang=ts&"
import style0 from "./editNewImageText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports